import React, { useState, useEffect, useRef } from 'react'
import { Navbar, Nav, Container } from 'react-bootstrap';
import logo from '../assets/eici_logo.jpg';
import cbic from '../assets/logo_new.png';
import home from '../assets/home-nav.png';
import imports from '../assets/imports.png';
import exports from '../assets/export.png';
import { Link } from 'react-router-dom';

const Navbars = () => {
     const [openSidebar, setOpenSidebar] = useState(false);

  // Reference to the sidebar and toggle button to detect clicks outside
  const sidebarRef = useRef(null);
  const toggleRef = useRef(null);

  // Close sidebar if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !toggleRef.current.contains(event.target)
      ) {
        setOpenSidebar(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSidebarToggle = () => setOpenSidebar(!openSidebar);
  return (
    <>
      {/* Navbar with Hamburger Icon on the Left */}
      <Navbar variant="dark" className="navbar-bg">
        <Container>
          <Navbar.Toggle
            aria-controls="collapsible-sidebar"
            onClick={handleSidebarToggle}
            className="mr-auto"
            ref={toggleRef}
          />
          
           <Navbar.Brand as={Link} to="/home" className="mx-auto">
            <img src={logo} height="55" alt="Center Logo" loading='lazy'/>
          </Navbar.Brand>

          <div>
            <img src={cbic} height="60" alt="Right Logo" loading='lazy'/>
          </div>
        </Container>
      </Navbar>
      
     {/* Collapsible Sidebar */}
<div className={`sidebar${openSidebar ? " show" : ""}`} ref={sidebarRef}>
    <div className="sidebar-content">
      <div className="sidebar-top">
        <img src={logo} alt="Sidebar Logo" height="50" className="sidebar-logo-img" loading='lazy'/>
        <h6 className='sidebar-logo-img-title'>Express Cargo Clearance System (ECCS)</h6>
      </div>

      <div className="sidebar-bottom">
        <Nav className="flex-column sidebar-links">
          <Nav.Link as={Link} to="/home">
            <img src={home} alt="Home" height="20" className="sidebar-icon" loading='lazy'/>
            <span className='nav-link-title'>Home</span>
          </Nav.Link>
          <Nav.Link as={Link} to="/import">
            <img src={imports} alt="About" height="20" className="sidebar-icon" loading='lazy'/>
            <span className='nav-link-title'>Present Status of Import Shipment</span>
          </Nav.Link>
          <Nav.Link as={Link} to="/export">
            <img src={imports} alt="Services" height="20" className="sidebar-icon" loading='lazy'/>
            <span className='nav-link-title'>Present Status of Export Shipment</span>
          </Nav.Link>
          <Nav.Link as={Link} to="/cbetoidpms">
            <img src={exports} alt="Contact" height="20" className="sidebar-icon" loading='lazy'/>
            <span className='nav-link-title'>Status of Transmission of CBE to RBI-IDPMS</span>
          </Nav.Link>
          <Nav.Link as={Link} to="/csbtoedpms">
            <img src={exports} alt="Contact" height="20" className="sidebar-icon" loading='lazy'/>
            <span className='nav-link-title'>Status of Transmission of CSB to RBI-EDPMS</span>
          </Nav.Link>
          <Nav.Link href="https://enquiry.icegate.gov.in/BE_HelpDesk_View/getInsertBEDetailsPage" target='_blank' rel="noopener noreferrer">
            <img src={exports} alt="Contact" height="20" className="sidebar-icon" loading='lazy'/>
            <span className='nav-link-title'>Status of CBE of GSTIN</span>
          </Nav.Link>
          <Nav.Link href="https://enquiry.icegate.gov.in/enquiryatices/manual-sb-input" target='_blank' rel="noopener noreferrer">
            <img src={exports} alt="Contact" height="20" className="sidebar-icon" loading='lazy'/>
            <span className='nav-link-title'>Status of CSBs Transmission to ICEGATE</span>
          </Nav.Link>
        </Nav>
      </div>
    </div>
</div>
</>
  )
}
export default Navbars
